import { ArrowRight, type LucideIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';

type SendMoneyMethodCardProps = {
  title: string;
  description: string;
  icon: LucideIcon;
  badge?: string;
  disabled?: boolean;
  onSelect: () => void;
};

export default function SendMoneyMethodCard({ title, description, icon: Icon, badge, disabled = false, onSelect }: SendMoneyMethodCardProps) {
  return (
    <article className="flex min-w-0 flex-col rounded-[1.4rem] border border-primary bg-main p-[1.8rem] sm:p-[2.4rem]">
      <div className="flex min-w-0 items-start justify-between gap-[1.2rem]">
        <span className="grid h-[4.8rem] w-[4.8rem] shrink-0 place-items-center rounded-[1.2rem] bg-action-secondary text-action-secondary">
          <Icon className="h-[2.4rem] w-[2.4rem]" strokeWidth={1.8} />
        </span>
        {badge && <span className="shrink-0 rounded-full border border-primary bg-secondary px-[1rem] py-[0.5rem] text-[1.2rem] font-medium leading-none text-second">{badge}</span>}
      </div>

      <h2 className="mt-[2rem] text-[2rem] font-semibold leading-[2.8rem] text-main">{title}</h2>
      <p className="mt-[0.8rem] min-h-[4.4rem] text-[1.4rem] leading-[2.2rem] text-second">{description}</p>

      <Button
        type="button"
        variant={disabled ? 'second' : 'default'}
        size="sz48"
        align="between"
        disabled={disabled}
        onClick={onSelect}
        className="mt-[2.4rem] w-full"
      >
        <span>{disabled ? 'Coming soon' : `Choose ${title.toLowerCase()}`}</span>
        {!disabled && <ArrowRight className="h-[1.8rem] w-[1.8rem]" />}
      </Button>
    </article>
  );
}
